var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('ServiceTaskDefaultTable',{attrs:{"items":_vm.data},on:{"remove":function($event){return _vm.getData()}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }